import { render, staticRenderFns } from "./FormEmail.vue?vue&type=template&id=673f028f&scoped=true&"
import script from "./FormEmail.vue?vue&type=script&lang=js&"
export * from "./FormEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f028f",
  null
  
)

export default component.exports